import React from 'react';
import {useFormContext} from 'react-hook-form';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';
import {ControllerWrapper} from '@/components/common';
import {SoopInputBox} from '@soop-ui/soop-ui';
import {FORM_FIELDS} from '@/constants/help/index';
import {useFormLabels} from '@/hooks/help/useFormLabels';
import {useFormClear} from '@/hooks/help/useFormClear';
import {useFormKeyHandler} from '@/hooks/help/useFormKeyHandler';

const ReporterName = () => {
  
  const {
    formState: {errors},
  } = useFormContext();
  const {title} = useFormLabels();
  const {handleFormKeyDown} = useFormKeyHandler();
  const {handleClear} = useFormClear();
  

  const onClear = () =>
    handleClear(FORM_FIELDS.REPORTER_NAME, {shouldFocus: true});
  const reporterNameLabel = `${title}·요청자 이름`;

  const REPORTER_NAME_ERROR_MESSAGE = `${reporterNameLabel}을 입력해 주세요.`;
  const REPORTER_NAME_MIN_LENGTH_ERROR_MESSAGE = `${reporterNameLabel}을 2자 이상 입력해 주세요.`;

  return (
    <div className={`${styles.section}`}>
      <label className={styles.label}>
        {`${reporterNameLabel}(기관·단체명)`} <em>*</em>
      </label>
      <ControllerWrapper
        component={SoopInputBox}
        needsBlurWrapper={true}
        clearable={true}
        onClear={onClear}
        size='44'
        name={FORM_FIELDS.REPORTER_NAME}
        rules={{
          required: REPORTER_NAME_ERROR_MESSAGE,
          minLength: {
            value: 2,
            message: REPORTER_NAME_MIN_LENGTH_ERROR_MESSAGE,
          },
        }}
        placeholder={`${reporterNameLabel}`}
        error={!!errors[FORM_FIELDS.REPORTER_NAME]}
        helperStatus={errors[FORM_FIELDS.REPORTER_NAME] ? 'error' : undefined}
        helperText={errors[FORM_FIELDS.REPORTER_NAME]?.message as string}
        onKeyDown={(e) => {
          handleFormKeyDown(e);
        }}
      />
    </div>
  );
};

export default ReporterName;
